
export default function HowItWorksSection() {
  const steps = [
    {
      step: '01',
      title: 'Market Entry & Sales Outreach',
      description: 'We don\'t just "visit" customers; we find the right people. We use our local network to find business opportunities and set up meetings with real decision-makers for you.',
      goal: 'Get your products in front of the right US buyers.',
      image: 'https://public.readdy.ai/ai/img_res/67a330218196e1f380a153e1af7c3dda.jpg'
    },
    {
      step: '02',
      title: 'Product Demo & "Home Base"',
      description: 'Skip the expensive hotel lobbies. Use our professional office to show your products to clients. It is a perfect space for "light demos," technical meetings, and working during your US business trips.',
      goal: 'A professional place to show your technology and host guests.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20office%20space%20with%20product%20demonstration%20setup%2C%20Taiwanese%20business%20professionals%20presenting%20technology%20to%20American%20clients%20in%20comfortable%20meeting%20room%2C%20representing%20professional%20demo%20environment%20and%20business%20home%20base%20in%20United%20States&width=400&height=300&seq=step2v2&orientation=landscape'
    },
    {
      step: '03',
      title: 'US Business Presence (Virtual Office)',
      description: 'Build trust by having a real US office address. We handle your mail and provide a local corporate identity, so your American customers feel more comfortable doing business with you.',
      goal: 'Make your company look like a local US business overnight.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20US%20business%20office%20building%20exterior%20with%20corporate%20signage%20and%20mail%20handling%20services%2C%20representing%20virtual%20office%20presence%20and%20local%20business%20identity%20for%20international%20companies%20establishing%20American%20market%20credibility&width=400&height=300&seq=step3v2&orientation=landscape'
    },
    {
      step: '04',
      title: 'Expert Network & Compliance',
      description: 'Setting up in the US is complicated. We connect you with trusted accountants, lawyers, and insurance experts who understand how to help Taiwanese companies succeed and stay safe.',
      goal: 'Professional help for your tax, legal, and business setup needs.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20consultants%20and%20legal%20experts%20reviewing%20compliance%20documents%20and%20business%20setup%20paperwork%2C%20accountants%20and%20lawyers%20working%20together%20on%20international%20business%20formation%2C%20representing%20expert%20network%20support%20for%20Taiwanese%20companies%20entering%20US%20market&width=400&height=300&seq=step4v2&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven 4-step process ensures Taiwanese businesses successfully enter and thrive in the U.S. market with strategic guidance and hands-on support.
          </p>
        </div>

        <div className="space-y-16">
          {steps.map((step, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="flex-1">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mr-4">
                    {step.step}
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900">{step.title}</h3>
                </div>
                <p className="text-lg text-gray-600 leading-relaxed mb-4">{step.description}</p>
                <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded-r-lg">
                  <p className="text-base font-semibold text-blue-900">
                    <span className="text-blue-700">The Goal:</span> {step.goal}
                  </p>
                </div>
              </div>
              <div className="flex-1">
                <img 
                  src={step.image} 
                  alt={step.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
